"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class DcChargeStation extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'dcChargeStation';
        this._lat = initParams.lat;
        this._lng = initParams.lng;
        this._name = initParams.name;
        this._formattedAddress = initParams.formatted_address;
        this._available = initParams.available;
        this._chargePoints = (0, util_1.camelArray)(initParams.charge_points);
    }
    set lat(value) {
        console.error('Do not set objects this way');
    }
    get lat() {
        return this._lat;
    }
    set lng(value) {
        console.error('Do not set objects this way');
    }
    get lng() {
        return this._lng;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set formattedAddress(value) {
        console.error('Do not set objects this way');
    }
    get formattedAddress() {
        return this._formattedAddress;
    }
    set available(value) {
        console.error('Do not set objects this way');
    }
    get available() {
        return this._available;
    }
    set chargePoints(value) {
        console.error('Do not set objects this way');
    }
    get chargePoints() {
        return this._chargePoints;
    }
}
exports.default = DcChargeStation;
//# sourceMappingURL=dcChargeStation.js.map